import { queryOptions } from '@tanstack/react-query';

import type { Tables } from '@archetelos/db';

import { supabase } from '@/lib/supabase';

export type CreatorApplication = Tables<'creator_applications'>;

export const creatorApplicationQueries = {
  latestForUser: (userId: string | undefined) =>
    queryOptions({
      queryKey: ['creator-application', 'latest', userId] as const,
      queryFn: async (): Promise<CreatorApplication | null> => {
        if (!userId) return null;
        const { data, error } = await supabase
          .from('creator_applications')
          .select('*')
          .eq('user_id', userId)
          .order('created_at', { ascending: false })
          .limit(1)
          .maybeSingle();
        if (error) throw error;
        return data as CreatorApplication | null;
      },
      enabled: Boolean(userId),
    }),
};
